// 置き換え対象のcarryID
export const REPLACE_ID = {
  CARRY_ID: `{carryId}`,
};

// 会員登録用リンク
export const MEMBER_REGIST_LINK = `/dcfront/member/memberRegist/?entry_id=26&carry_id=${REPLACE_ID.CARRY_ID}&carry_class=k`;

// 「ログインはこちら」用リンク
export const GUIDE_LOGIN_LINK = '/dcfront/login/login/';

// 「はじめてdodaをご利用される方へ」用リンク
export const INTRO_LINK = '/intro/';

// ログアウト計測パラメータ
export const LOGOUT_PARAM_PC = 'usrclk=PC_logout_JobContent_';
export const LOGOUT_PARAM_SP = 'usrclk=SP_logout_JobContent_';

// 求人検索結果用リンク
export const JOB_SEARCH_LIST_URL = '/DodaFront/View/JobSearchList';
// 求人トレンド用リンク
export const JOB_TREND_URL = '/DodaFront/View/JobContent/JobTrend';
// 求人ランキング用リンク
export const JOB_RANKING_URL = '/DodaFront/View/JobContent/JobRanking';
// 年収職業用リンク
export const OCCUPATION_URL = '/DodaFront/View/JobContent/Occupation';
// 職種パラメータ
export const OCCUPATIONS_PARAM = '/j_oc__%sL/';
// 都道府県パラメータ
export const PREFECTURE_PARAM = '/j_pr__%s/';
// 海外パラメータ
export const ABROAD_AREAS_PARAM = '/j_ar__%s/';
// 業種パラメータ
export const INDUSTRY_PARAM = '/j_ind__%sL/';
// 雇用形態パラメータ
export const EMPLOYMENT_STATUS_PARAM = '/j_op__%s/';
// 年収パラメータ
export const HA_SEARCH_ITEMS_PARAM = '/j_ha__%s%2C0/';
// こだわりパラメータ
export const OP_SEARCH_ITEMS_PARAM = '/j_op__%s/';

// こだわり
export const OTHER_OP_SEARCH_ITEMS = [
  {
    id: '3',
    name: '第二新卒歓迎',
  },
  {
    id: '4',
    name: '外資系企業',
  },
  {
    id: '5',
    name: '年間休日120日以上',
  },
  {
    id: '6',
    name: 'フレックス勤務',
  },
  {
    id: '8',
    name: '管理職・マネジャー',
  },
  {
    id: '21',
    name: '英語を活かす',
  },
  {
    id: '24',
    name: '学歴不問',
  },
  {
    id: '27',
    name: '転勤なし（勤務地限定）',
  },
  {
    id: '32',
    name: '服装自由',
  },
  {
    id: '33',
    name: '女性活躍',
  },
  {
    id: '44',
    name: '社宅・家賃補助制度',
  },
  {
    id: '47',
    name: '上場企業',
  },
  {
    id: '49',
    name: '中国語を活かす',
  },
  {
    id: '56',
    name: '退職金制度',
  },
  {
    id: '60',
    name: '残業20時間未満',
  },
  {
    id: '69',
    name: '完全週休2日制',
  },
  {
    id: '70',
    name: '職種未経験歓迎',
  },
  {
    id: '72',
    name: '土日祝休み',
  },
  {
    id: '74',
    name: '原則定時退社',
  },
  {
    id: '78',
    name: '海外出張あり',
  },
  {
    id: '81',
    name: 'U・Iターン支援あり',
  },
] as const;

// 雇用形態
export const OTHER_EMPLOYMENT_STATUS = [
  {
    id: '17',
    name: '正社員',
  },
  {
    id: '18',
    name: '契約社員',
  },
  {
    id: '19',
    name: 'その他（FCオーナー・業務委託など）',
  },
] as const;

// 年収
export const OTHER_HA_SEARCH_ITEMS = [
  {
    id: '30',
    name: '300万円',
    seoText: '300万円～',
  },
  {
    id: '35',
    name: '350万円',
    seoText: '350万円～',
  },
  {
    id: '40',
    name: '400万円',
    seoText: '400万円～',
  },
  {
    id: '45',
    name: '450万円',
    seoText: '450万円～',
  },
  {
    id: '50',
    name: '500万円',
    seoText: '500万円～',
  },
  {
    id: '55',
    name: '550万円',
    seoText: '550万円～',
  },
  {
    id: '60',
    name: '600万円',
    seoText: '600万円～',
  },
  {
    id: '65',
    name: '650万円',
    seoText: '650万円～',
  },
  {
    id: '70',
    name: '700万円',
    seoText: '700万円～',
  },
  {
    id: '80',
    name: '800万円',
    seoText: '800万円～',
  },
  {
    id: '90',
    name: '900万円',
    seoText: '900万円～',
  },
  {
    id: '100',
    name: '1000万円',
    seoText: '1000万円～',
  },
] as const;

// OPパラメータ（新着）
export const NEW_OP_PARAM = '1';
// OPパラメータ（締切間近）
export const DEADLINE_OP_PARAM = '20';
// OPパラメータ（派遣社員）
export const TEMPORARY_WORKER_OP_PARAM = '57';
// OPパラメータ（紹介予定派遣）
export const TEMP_TO_PERM_OP_PARAM = '58';
// OPパラメータ（業務委託）
export const OUTSOURCING_OP_PARAM = '59';
// OPパラメータ（FCオーナー）
export const FC_OWNER_OP_PARAM = '64';

// 求人検索パンくず文言
export const JOB_SEARCH_BREAD_CRUMB_TEXT = 'の転職・求人情報';
// 求人トレンドパンくず文言
export const JOB_TREND_BREAD_CRUMB_TEXT = '求人の傾向';
// 求人ランキングパンくず文言
export const JOB_RANKING_BREAD_CRUMB_TEXT = '人気求人ランキング';

// 求人コンテンツ エージェント求人カードNoImage画像
export const AGENT_NO_IMAGE_PATH =
  '/resources/dcfront/Html/img_cmn/no_image_01.jpg';
// 求人コンテンツ 直接応募求人カードNoImage画像
export const DIRECT_NO_IMAGE_PATH =
  '/resources/dcfront/Html/img_cmn/no_image_direct_entry.jpg';
// 求人コンテンツ 求人カードNoImage画像
export const NO_IMAGE_PATH =
  '/resources/dcfront/Html/img_cmn/img_R60_D_190_01_job03.gif';

// 他へのページリンクテキスト
export const OTHER_PAGE_LINK_TITLE = 'の求人に関する情報';
export const JOB_SEARCH_LINK_TEXT = {
  TITLE: '求人一覧',
  DESCRIPTION: 'dodaに掲載中の求人情報一覧です。',
  IMAGE_PATH: '/cmn_web/img/index/icon_jobSearchList.png',
};
export const JOB_TREND_LINK_TEXT = {
  TITLE: '求人の傾向',
  DESCRIPTION:
    'dodaに掲載中の求人に関するデータを、カテゴリごとにご紹介します。',
  IMAGE_PATH: '/cmn_web/img/index/icon_jobTrend.png',
};
export const JOB_RANKING_LINK_TEXT = {
  TITLE: '人気求人ランキング',
  DESCRIPTION: 'dodaに掲載中の求人を、応募数順にランキング形式でご紹介します。',
  IMAGE_PATH: '/cmn_web/img/index/icon_jobRanking.png',
};
export const OCCUPATION_LINK_TEXT = {
  TITLE: '職業別の求人数',
  DESCRIPTION:
    'dodaに掲載中の求人を、年収×職種ごとにグラフ形式でご紹介します。',
  IMAGE_PATH: '/cmn_web/img/index/icon_occupation.png',
};

// ABテスト基盤呼び出し用
export const JOB_RANKING_LINK_AB_TEST_KEY = 'JobRanking_link';
export const JOB_RANKING_LINK_AB_TEST_COOKIE_KEY = 'seo_jobRanking_link_key';
export const JOB_RANKING_LINK_AB_TEST_COOKIE_TERM = 30;
export const JOB_RANKING_LINK_SHOW_GROUP_NO = '2';
